/**
 * @generated SignedSource<<095f9349ae3831afaabc404e4a86c88d>>
 * @relayHash 6908509fc024e1ab74ffec2140dcf167
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 6908509fc024e1ab74ffec2140dcf167

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type IssueClosedStateReason = "COMPLETED" | "NOT_PLANNED" | "%future added value";
export type IssueState = "CLOSED" | "OPEN" | "%future added value";
export type UpdateIssuesBulkInput = {
  addToProjectV2Ids?: ReadonlyArray<string> | null;
  applyAssigneeIds?: ReadonlyArray<string> | null;
  applyLabelIds?: ReadonlyArray<string> | null;
  clearMilestone?: boolean | null;
  clientMutationId?: string | null;
  ids: ReadonlyArray<string>;
  issueTypeId?: string | null;
  milestoneId?: string | null;
  removeAssigneeIds?: ReadonlyArray<string> | null;
  removeLabelIds?: ReadonlyArray<string> | null;
  state?: IssueState | null;
  stateReason?: IssueClosedStateReason | null;
  unsetIssueType?: boolean | null;
};
export type addIssuesToProjectsBulkMutation$variables = {
  input: UpdateIssuesBulkInput;
};
export type addIssuesToProjectsBulkMutation$data = {
  readonly updateIssuesBulk: {
    readonly jobId: string | null;
  } | null;
};
export type addIssuesToProjectsBulkMutation$rawResponse = {
  readonly updateIssuesBulk: {
    readonly jobId: string | null;
  } | null;
};
export type addIssuesToProjectsBulkMutation = {
  rawResponse: addIssuesToProjectsBulkMutation$rawResponse;
  response: addIssuesToProjectsBulkMutation$data;
  variables: addIssuesToProjectsBulkMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIssuesBulkPayload",
    "kind": "LinkedField",
    "name": "updateIssuesBulk",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "jobId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "addIssuesToProjectsBulkMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "addIssuesToProjectsBulkMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "6908509fc024e1ab74ffec2140dcf167",
    "metadata": {},
    "name": "addIssuesToProjectsBulkMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "63b0539aebe1a9b04411550192d240e1";

export default node;
